import { render, staticRenderFns } from "./AddNewProudct.vue?vue&type=template&id=47b0ae39&scoped=true"
import script from "./AddNewProudct.vue?vue&type=script&lang=js"
export * from "./AddNewProudct.vue?vue&type=script&lang=js"
import style0 from "./AddNewProudct.vue?vue&type=style&index=0&id=47b0ae39&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b0ae39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b0ae39')) {
      api.createRecord('47b0ae39', component.options)
    } else {
      api.reload('47b0ae39', component.options)
    }
    module.hot.accept("./AddNewProudct.vue?vue&type=template&id=47b0ae39&scoped=true", function () {
      api.rerender('47b0ae39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/sub-merchant/components/content/payment-link/components/Modal/AddNewProudct.vue"
export default component.exports